import tireDiscountersDefaults from '../09gv4m-m2/config.js';

export default {
  ...tireDiscountersDefaults,
  includes: ['shopify-enterprise-generic', '09gv4m-m2'],
};
